import TermsAndCondition from "./registrationConditions/T&C.js";
import lang from "./lang.json";

export default {
    lang,
    registrationTerms: [
        {
            label: "条款及细则",
            html: TermsAndCondition
        }
    ]
};
